import React from "react";
import { UseCtaStateResult } from "../../hooks/useCtaState";
import { CtaStrategy } from "../../config/CtaStrategyConfig";
import "./styles/ButtonCta.css";

interface ButtonCtaProps {
  cta: CtaStrategy;
  ctaState: UseCtaStateResult;
}

const ButtonCta: React.FC<ButtonCtaProps> = ({ cta, ctaState }) => {
  const { openOfferModal } = ctaState;

  return (
    <div className="btncta__bar">
      <button className="btncta__primary" onClick={openOfferModal}>
        {cta.primaryLabel}
      </button>
    </div>
  );
};

export default ButtonCta;
